import dayjs from "dayjs";

import { getCampaignMaxAvailableDate } from "app/components/widget/widget-utilities/Campaigns/CampaignsUtils";
import { DEFAULT_RT_DURATION, WEEK_DAYS } from "app/pages/activation/components/RankWidget/config";
import { dateFormats } from "app/pages/activation/constants/dates";
import type { RankTrackerCampaign } from "app/pages/activation/types/api";

type RtWidgetDateSource = Pick<RankTrackerCampaign, "firstScrapeTime"> &
    Partial<Pick<RankTrackerCampaign, "lastScrapeDate">>;

type RtWidgetDates = {
    from: string;
    to: string;
    range: string;
    duration: string;
};

export const getRTDates = (campaign?: RtWidgetDateSource | null): Partial<RtWidgetDates> => {
    if (!campaign?.firstScrapeTime) {
        return {};
    }

    // ActivationRT uses the same LastAvailableRankTrackerEtlDate as RT
    const to = getCampaignMaxAvailableDate(campaign.lastScrapeDate);

    const toDate = dayjs(to);
    const firstScrapeDate = dayjs(campaign.firstScrapeTime);
    const daysDifference = toDate.diff(firstScrapeDate, "day");
    const from = daysDifference >= WEEK_DAYS ? toDate.subtract(WEEK_DAYS, "day") : firstScrapeDate;

    const formatedTo = toDate.format(dateFormats.beDateFormat);
    const formatedFrom = from.format(dateFormats.beDateFormat);
    const duration = daysDifference < WEEK_DAYS ? `${daysDifference}d` : DEFAULT_RT_DURATION;

    const range = `${from.format(dateFormats.shortMonthDayYear)} vs. ${toDate.format(dateFormats.shortMonthDayYear)}`;

    return {
        from: formatedFrom,
        to: formatedTo,
        range,
        duration,
    };
};
